import type {CanvasChatMessage,CanvasPlaceholder} from './canvas-types';

const ongoingEvents=new Set(['playbook_start','playbook_phase_start','playbook_phase_progress','canvas_image_pending','canvas_image_generating','canvas_image_progress','agent_thinking']);

/** An old live stream cannot reopen an already settled durable job. */
export function ignoresSettledPlaybookEvent(message:CanvasChatMessage|undefined,type:string):boolean {
  const jobs=message?.playbookJobs;
  return ongoingEvents.has(type) && !!jobs?.length && jobs.every(job=>['completed','failed','cancelled'].includes(job.status));
}

/** Progress changes only an existing slot belonging to the originating turn. */
export function applyCanvasImageProgress(placeholders:Record<string,CanvasPlaceholder>,messages:CanvasChatMessage[],messageId:string,data:any) {
  const owner=messages.find(message=>message.id===messageId);
  if(typeof data?.requestId!=='string' || typeof data.statusText!=='string' || ignoresSettledPlaybookEvent(owner,'canvas_image_progress')) return {placeholders,messages};
  const taskId=`agent-img-${data.requestId}`;
  const placeholder=placeholders[taskId];
  const matchesRun=(runId?:number)=>data.workflowRunId==null || runId==null || runId===data.workflowRunId;
  const nextPlaceholders=placeholder && placeholder.batchId===messageId && !placeholder.failed && !placeholder.resolving && matchesRun(placeholder.workflowRunId)
    ? {...placeholders,[taskId]:{...placeholder,statusText:data.statusText}}
    : placeholders;
  const nextMessages=messages.map(message=>message.id!==messageId || !message.imageSlots ? message : {
    ...message,imageSlots:message.imageSlots.map(slot=>slot.requestId===data.requestId && matchesRun(slot.workflowRunId) && !slot.resolved && !slot.failed ? {...slot,statusText:data.statusText}:slot),
  });
  return {placeholders:nextPlaceholders,messages:nextMessages};
}
